import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {trackReservationStart} from "../tracking/track_reservation_events";
import {IReservationRequest} from "../types/IReservationRequest";
import {useStartReservationRegistration} from "./use_start_reservation_registration";

export interface IUseStartReservationFlowOptions {
    // reported by pre_form_open of the buttons on the property page
    offerName?: string | null;
}

// The click of a reservation button - it never goes through the unlock choice or the post-registration lead; without a request it does nothing
export const useStartReservationFlow = (request: IReservationRequest | null, options: IUseStartReservationFlowOptions = {}): (() => void) => {
    const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();
    const startReservationRegistration = useStartReservationRegistration();

    return () => {
        if (!request) {
            return;
        }

        trackReservationStart(request, {offerName: options.offerName});
        startReservationRegistration(request, {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified});
    };
};
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {trackReservationStart} from "../tracking/track_reservation_events";
import {IReservationRequest} from "../types/IReservationRequest";
import {useStartReservationRegistration} from "./use_start_reservation_registration";

export interface IUseStartReservationFlowOptions {
    // reported by pre_form_open of the buttons on the property page
    offerName?: string | null;
}

// The click of a reservation button - it never goes through the unlock choice or the post-registration lead; without a request it does nothing
export const useStartReservationFlow = (request: IReservationRequest | null, options: IUseStartReservationFlowOptions = {}): (() => void) => {
    const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();
    const startReservationRegistration = useStartReservationRegistration();

    return () => {
        if (!request) {
            return;
        }

        trackReservationStart(request, {offerName: options.offerName});
        startReservationRegistration(request, {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified});
    };
};
